import { useState, useEffect } from "react";
import useFlag, { KeyWhatIsNewType, FLAG_WHAT_IS_NEW } from "state/useFlag";
import { atom, useRecoilState } from "recoil";

// const fullWhatIsNewState = atom({
//   key: "fullWhatIsNewState",
//   default: undefined as undefined | boolean,
// });

// export const useWhatIsNewState = () => {
//   const [isShowFullWhatisNew, setIsShowFullWhatisNew] = useRecoilState(fullWhatIsNewState);
//   return {
//     isShowFullWhatisNew,
//     setIsShowFullWhatisNew,
//   };
// };

export const useWhatIsNewModal = (flag: KeyWhatIsNewType) => {
  const { flags, readWhatIsNew } = useFlag();
  // const { isShowFullWhatisNew, setIsShowFullWhatisNew } = useWhatIsNewState();
  // const [open, setOpen] = useState(false);
  const flagState = flags?.[flag]?.flag;
  const [open, setOpen] = useState(flagState);
  // useEffect(() => {
  //   if (flag === "new_feature_full" && flags?.[flag]) {
  //     setIsShowFullWhatisNew(true);
  //     setOpen(true);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (isShowFullWhatisNew === false && flag !== "new_feature_full" && flags?.[flag]) {
  //     setOpen(true);
  //   }
  // }, [isShowFullWhatisNew]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    flagState && readWhatIsNew(flag, false);
  };
  const handleLastClose = () => {
    setOpen(false);
    // flag === "new_feature_full" && setIsShowFullWhatisNew(false);
    flagState && readWhatIsNew(flag, true);
  };
  return {
    open,
    handleOpen,
    handleClose,
    handleLastClose,
  };
};
